import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { C } from "@/brand/tokens";
import { navLinks } from "@/brand/content";
import { FaithMark } from "@/components/brand/FaithMark";

/**
 * SiteHeader — Smoked Ink chamber threshold.
 *
 * Bottom rule is Restrained Brass at 30% — the first structural rail
 * the visitor crosses. Sticky with subtle backdrop blur so it reads
 * as architectural rather than as a transparent floating bar.
 */
export function SiteHeader({ homeHref = "/concept-d", ctaHref = "#contact" }) {
  return (
    <header
      className="sticky top-0 z-40 backdrop-blur"
      style={{
        background: `${C.bgDark}EE`,
        borderBottom: `1px solid ${C.brassSoft}`,
      }}
    >
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-14 h-24 flex items-center justify-between">
        <Link
          to={homeHref}
          data-testid="brand-mark"
          className="inline-flex"
          aria-label="Faith 1st — home"
        >
          <FaithMark size="sm" tone="light" />
        </Link>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-9">
          {navLinks.map((l) => (
            <a
              key={l}
              href="#"
              data-testid={`nav-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-inter text-[12px] uppercase font-medium transition-colors whitespace-nowrap"
              style={{
                color: C.whiteOnDark,
                letterSpacing: "0.18em",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = C.accentMetal)}
              onMouseLeave={(e) => (e.currentTarget.style.color = C.whiteOnDark)}
            >
              {l}
            </a>
          ))}
        </nav>

        <a
          href={ctaHref}
          data-testid="nav-cta"
          className="hidden sm:inline-flex items-center gap-2.5 px-5 py-3 font-inter text-[11px] uppercase font-semibold whitespace-nowrap transition-colors"
          style={{
            background: "transparent",
            color: C.textOnDark,
            border: `1px solid ${C.accentMetal}`,
            letterSpacing: "0.22em",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = C.accentMetal;
            e.currentTarget.style.color = C.bgDark;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.color = C.textOnDark;
          }}
        >
          Start the conversation
          <ArrowRight size={12} weight="bold" />
        </a>
      </div>
    </header>
  );
}
